export default __webpack_public_path__ + "static/media/projectCodeEdit.c137b7f1.png";